import styled, { keyframes } from 'styled-components';

const wobble = keyframes`
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(10deg);
  }
  75% {
    transform: rotate(-5deg);
  }
`;

export const WobbleIcon = styled.div`
  display: inline-flex;
  animation: ${wobble} 1s ease-in-out infinite;
  animation-delay: ${() => Math.random() * 2}s;

  &:hover {
    animation: none;
  }
`;
